import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import OTPInput from 'react-otp-input';
import { Link, useNavigate } from 'react-router-dom'

export default function OTP() {
    const imageUrl = "./assets/images/";
    const { register, handleSubmit, reset, formState: { errors },
    } = useForm();
    const navigate = useNavigate()
    // show hide password 
    // login api
    const loginUser = async (data) => {
        navigate("/resetPassword");
    };
    return (

        <div className="login-form">
            <div className="text-center mb-8">
                <h1 className='heading-color Sora_SB text-3xl mb-2'>Enter OTP</h1>
                <p className='Sora_R opacity-80 text-sm'>Please enter your code</p>
            </div>
            <form onSubmit={handleSubmit(loginUser)}>
                <div className="form-group my-8">
                    <label for>Enter OTP</label>
                    <div className="otp otpContainer">
                        <OTPInput
                            inputStyle="pin-input input-box"
                            containerStyle="enterpin-area w-100 gap-5 mt-2"
                            numInputs={5}
                            // value={otpValue}
                            isInputNum={true}
                            // onChange={(value) => setOtp(value)}
                            separator={<span> &nbsp;</span>}
                            renderInput={(props) => <input {...props} />}
                        />
                    </div>
                </div>
                <div class="flex items-center justify-between ">
                    <button type="submit" class="btn w-full text-center">
                        Submit
                    </button>
                </div>
                <div className="w-full mt-8 justify-center flex items-center">
                    <Link class="inline-block align-baseline text-sm ps-1" to="">
                        Resend OTP
                    </Link>
                </div>
            </form>
        </div >
    )
}
